import { render, staticRenderFns } from "./RGPDStarApp.vue?vue&type=template&id=4d53cd67&scoped=true"
import script from "./RGPDStarApp.vue?vue&type=script&lang=ts"
export * from "./RGPDStarApp.vue?vue&type=script&lang=ts"
import style0 from "./RGPDStarApp.vue?vue&type=style&index=0&id=4d53cd67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d53cd67",
  null
  
)

export default component.exports